import { Validators } from '@angular/forms';
import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Container, Custom, Textbox } from '@app/shared/dynamic-form';
import { isEmpty, result } from 'lodash';

export interface ConfigFields {
}

@Injectable()
export class ManageSecondaryDetailFormService {
  constructor() {}
  /**
   * Retorna el formulario de detalles de la secundaria
   *
   * @param {*} objectModel
   * @return {*}  {BaseControl<any>[]}
   * @memberof ManageSecondaryDetailFormService
   */
  getFormTramit(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: "form-row",
        order: 1,
        controls:[
          new Custom({
            key: 'categoria',
            label: 'Categoría',
            value: null,
            size: 'col-12 col-lg-12',
            template: objectModel.categoriaTmpl,
            placeholder: 'Seleccione la categoría',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'proceso',
            label: 'Proceso',
            size: 'col-12 col-lg-12',
            value: null,
            template: objectModel.procesoTmpl,
            placeholder: 'Seleccione el proceso',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'categoria',
                siEs: 'Vacio',
                accion: 'Bloquear'
              }
            ]
          }),
          new Custom({
            key: 'tramite',
            label: 'Trámite',
            size: 'col-12 col-lg-12',
            value: null,
            template: objectModel.tramiteTmpl,
            placeholder: 'Seleccione el trámite',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'proceso',
                siEs: 'Vacio',
                accion: 'Bloquear'
              }
            ]
          })
        ]})
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-detail/shared/manage-secondary-detail.form.service.ts